import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, api, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure211 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    excutiveRole: "",
    nonExecPosition: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        console.log("didata", res?.data?.data?.year);
        console.log("didata1", disabled);
        setFromData({
          excutiveRole:
            res.data.data.GeneralDisclosures2021.chairExecPosition.excutiveRole,
          nonExecPosition:
            res.data.data.GeneralDisclosures2021.chairExecPosition
              .nonExecPosition,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    if (!disabled) {
      // const validationErrors = validateFields();

      // If there are errors, prevent form submission
      // if (Object.keys(validationErrors).length > 0) {
      //   console.log("Form contains errors", fromData, validationErrors);
      //   return;
      // }
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`${api}/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          chairExecPosition: { ...fromData },
          submitted2_11: true,
        });
        navigate(`/gri/general-disclosure/2-12/${id}`);
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-12/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Does the chair of the highest governance body also hold a senior executive position within the organization ?",
      fieldName: "nonExecPosition",
    },

    {
      index: "b.",
      heading:
        "If the chair is also a senior executive, what specific role do they hold within the organization's management structure?",
      fieldName: "excutiveRole",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-11 Chair of the highest governance body"
        {...{
          inputData,
          fromData,
          setFromData,
          disabled: disabled,
          setErrors,
          errors,
          hide
        }}
      />
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure211;
